import { fetchWordPressResource } from "./client";
import { wordpressEndpoints } from "./endpoints";
import {
  buildAppsQuery,
  buildPagesQuery,
  buildPostsQuery,
  buildTaxonomyQuery,
} from "./queries";

export function fetchPosts(options = {}) {
  return fetchWordPressResource({
    pathCandidates: wordpressEndpoints.posts,
    params: buildPostsQuery(options),
    signal: options.signal,
  });
}

export function fetchPostBySlug(slug, options = {}) {
  return fetchWordPressResource({
    pathCandidates: wordpressEndpoints.postBySlug,
    params: buildPostsQuery({ ...options, slug, limit: 1 }),
    signal: options.signal,
  });
}

export function fetchPages(options = {}) {
  return fetchWordPressResource({
    pathCandidates: wordpressEndpoints.pages,
    params: buildPagesQuery(options),
    signal: options.signal,
  });
}

export function fetchPageBySlug(slug, options = {}) {
  return fetchWordPressResource({
    pathCandidates: wordpressEndpoints.pageBySlug,
    params: buildPagesQuery({ ...options, slug, limit: 1 }),
    signal: options.signal,
  });
}

export function fetchApps(options = {}) {
  return fetchWordPressResource({
    pathCandidates: wordpressEndpoints.apps,
    params: buildAppsQuery(options),
    signal: options.signal,
  });
}

export function fetchAppBySlug(slug, options = {}) {
  return fetchWordPressResource({
    pathCandidates: wordpressEndpoints.appBySlug,
    params: buildAppsQuery({ ...options, slug, limit: 1 }),
    signal: options.signal,
  });
}

export function fetchCategories(options = {}) {
  return fetchWordPressResource({
    pathCandidates: wordpressEndpoints.categories,
    params: buildTaxonomyQuery(options),
    signal: options.signal,
  });
}

export function fetchTags(options = {}) {
  return fetchWordPressResource({
    pathCandidates: wordpressEndpoints.tags,
    params: buildTaxonomyQuery(options),
    signal: options.signal,
  });
}

export function fetchSiteSettings(options = {}) {
  return fetchWordPressResource({
    pathCandidates: wordpressEndpoints.siteSettings,
    params: {},
    signal: options.signal,
  });
}

export function fetchNavigation(options = {}) {
  return fetchWordPressResource({
    pathCandidates: wordpressEndpoints.navigation,
    params: {},
    signal: options.signal,
  });
}
